import { FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useProyecto } from '../../../data/ProyectoContext';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const CondicionesContexto = () => {
    
    const { proyecto, setProyecto } = useProyecto();
    const { promptData, setPromptData} = useActividadesContext();

    const value_condiciones_contexto =  promptData.condiciones_contexto ?? ''

    const handleIndicationsProyectChange = (event) => {
        const { value } = event.target;
        setProyecto({...proyecto,  condiciones_contexto: value
        });
        setPromptData((prevData) => ({
            ...prevData,
            condiciones_contexto: value 
          }));
      };
    
    return (
        <Grid xs={12} lg={12} md={12}>
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }} > Condiciones de contexto </Typography>
            <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}> Describe las condiciones específicas del entorno de aprendizaje en tu clase, escuela o región. Esto puede incluir el tipo de recursos o tecnología disponibles, número de estudiantes, características del aula o del entorno que puedan influir en el aprendizaje.</FormLabel>
            <TextField
                required
                id="contexto"
                placeholder='Escuela rural en la región de la Araucanía, Chile. Aula con acceso a internet y dispositivos digitales para cada estudiante'
                name="contexto"
                fullWidth
                autoComplete="given-name"
                variant="outlined"
                value={value_condiciones_contexto}
                onChange={handleIndicationsProyectChange}
                InputProps={{
                    sx: {
                        borderRadius:2,
                        mt:1,
                        mb: 3,
                        fontFamily: 'montserrat',
                        fontSize: '0.75rem',
                        color: '#005559',
                        '&::placeholder': {
                            color: '#005559',

                        },
                        '&:before': {
                            borderBottomColor: '#005559',

                        },
                        '&:after': {
                            borderBottomColor: '#005559',
                        },
                    }
                }}
            />
        </Grid>
    );
};

export default CondicionesContexto;




